/* =========================================================
   Southern Made – collection page behaviour
   <sm-collection> : AJAX filters + sort (Section Rendering API),
                     load more, filter drawer, grid toggle, quick add
   ========================================================= */
(function () {
  if (customElements.get('sm-collection')) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var DESKTOP = window.matchMedia('(min-width: 1200px)');

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  function store(key, value) {
    try {
      if (value === undefined) return window.localStorage.getItem(key);
      window.localStorage.setItem(key, value);
    } catch (e) { return null; }
    return null;
  }

  class SmCollection extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      onReady(this.init.bind(this));
    }

    init() {
      this.sectionId = this.dataset.sectionId;
      this.baseUrl = this.dataset.url;
      this.panel = this.querySelector('.SmFilters');
      this.overlay = this.querySelector('.SmOverlay');
      this.layout = this.dataset.layout;
      this.controller = null;

      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('input', this.onInput.bind(this));
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('submit', function (e) { e.preventDefault(); });
      if (this.overlay) this.overlay.addEventListener('click', this.closeFilters.bind(this));
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') this.closeFilters(); }.bind(this));
      window.addEventListener('popstate', function () { this.load(window.location.search.replace(/^\?/, ''), false); }.bind(this));
      var onBp = function () { if (DESKTOP.matches && this.layout === 'sidebar') this.closeFilters(); }.bind(this);
      if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', onBp); else DESKTOP.addListener(onBp);

      this.applyView();
      this.syncRanges();
    }

    /* ---------------- events ---------------- */
    onChange(e) {
      var t = e.target;
      if (t.matches('[data-sm-sort]') || t.closest('[data-sm-filter-form]')) {
        if (t.type === 'range') { this.commitRange(t); return; }
        this.submit();
      }
    }

    onInput(e) {
      if (e.target.type === 'range') this.dragRange(e.target);
    }

    onClick(e) {
      var el;
      if ((el = e.target.closest('[data-sm-open-filters]'))) { e.preventDefault(); this.openFilters(); return; }
      if ((el = e.target.closest('[data-sm-close]'))) { e.preventDefault(); this.closeFilters(); return; }
      if ((el = e.target.closest('[data-sm-link]'))) {
        e.preventDefault();
        var href = el.getAttribute('href') || '';
        this.load(href.indexOf('?') > -1 ? href.split('?')[1] : '', true);
        return;
      }
      if ((el = e.target.closest('[data-sm-more]'))) { e.preventDefault(); this.loadMore(el); return; }
      if ((el = e.target.closest('[data-sm-view]'))) { e.preventDefault(); this.setView(el); return; }
      if ((el = e.target.closest('[data-sm-quick-add]'))) { e.preventDefault(); this.quickAdd(el); }
    }

    /* ---------------- filtering ---------------- */
    params() {
      var form = this.querySelector('[data-sm-filter-form]');
      var data = form ? new FormData(form) : new FormData();
      var sort = this.querySelector('[data-sm-sort]');
      var out = new URLSearchParams();

      data.forEach(function (value, key) {
        if (value === '' || value === null) return;
        var input = form.querySelector('[name="' + key + '"][data-sm-price]');
        if (input) {
          var num = parseFloat(value);
          if (isNaN(num)) return;
          if (input.dataset.smPrice === 'min' && num <= parseFloat(input.dataset.floor)) return;
          if (input.dataset.smPrice === 'max' && num >= parseFloat(input.dataset.ceil)) return;
        }
        out.append(key, value);
      });
      if (sort && sort.value) out.set('sort_by', sort.value);
      return out.toString();
    }

    submit() {
      clearTimeout(this._t);
      this._t = setTimeout(function () { this.load(this.params(), true); }.bind(this), 120);
    }

    load(query, push) {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();

      var grid = this.querySelector('.SmGrid');
      if (grid) grid.classList.add('is-loading');

      var url = this.baseUrl + '?' + (query ? query + '&' : '') + 'section_id=' + this.sectionId;
      var self = this;

      fetch(url, { signal: this.controller.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          self.swap(doc);
          if (push) {
            var clean = self.baseUrl + (query ? '?' + query : '');
            window.history.pushState({ sm: true }, '', clean);
          }
        })
        .catch(function (err) {
          if (err.name === 'AbortError') return;
          window.location.href = self.baseUrl + (query ? '?' + query : '');
        });
    }

    swap(doc) {
      var fresh = doc.querySelector('sm-collection');
      if (!fresh) return;

      /* results */
      var results = this.querySelector('[data-sm-results]');
      var newResults = fresh.querySelector('[data-sm-results]');
      if (results && newResults) results.innerHTML = newResults.innerHTML;

      /* filters – keep open groups + scroll position */
      var form = this.querySelector('[data-sm-filter-form]');
      var newForm = fresh.querySelector('[data-sm-filter-form]');
      if (form && newForm) {
        var open = {};
        form.querySelectorAll('details[data-sm-group]').forEach(function (d) { open[d.dataset.smGroup] = d.open; });
        var scroll = form.scrollTop;
        form.innerHTML = newForm.innerHTML;
        form.querySelectorAll('details[data-sm-group]').forEach(function (d) {
          if (d.dataset.smGroup in open) d.open = open[d.dataset.smGroup];
        });
        form.scrollTop = scroll;
      }

      var foot = this.querySelector('.SmFilters__Foot');
      var newFoot = fresh.querySelector('.SmFilters__Foot');
      if (foot && newFoot) foot.innerHTML = newFoot.innerHTML;

      this.applyView();
      this.syncRanges();
    }

    /* ---------------- price range ---------------- */
    syncRanges() {
      this.querySelectorAll('[data-sm-range]').forEach(function (wrap) {
        var min = wrap.querySelector('[data-sm-range-min]');
        var max = wrap.querySelector('[data-sm-range-max]');
        var fill = wrap.querySelector('.SmRange__Fill');
        if (!min || !max || !fill) return;
        var floor = parseFloat(min.min), ceil = parseFloat(min.max), span = (ceil - floor) || 1;
        fill.style.left = ((parseFloat(min.value) - floor) / span * 100) + '%';
        fill.style.right = (100 - (parseFloat(max.value) - floor) / span * 100) + '%';
      });
    }

    dragRange(input) {
      var wrap = input.closest('[data-sm-range]');
      var group = input.closest('.SmFgroup__Body');
      var min = wrap.querySelector('[data-sm-range-min]');
      var max = wrap.querySelector('[data-sm-range-max]');
      if (parseFloat(min.value) > parseFloat(max.value)) {
        if (input === min) min.value = max.value; else max.value = min.value;
      }
      group.querySelector('[data-sm-price="min"]').value = min.value;
      group.querySelector('[data-sm-price="max"]').value = max.value;
      this.syncRanges();
    }

    commitRange() { this.submit(); }

    /* ---------------- load more ---------------- */
    loadMore(btn) {
      var next = btn.dataset.next;
      if (!next || btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      var self = this;
      var url = next + (next.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + this.sectionId;

      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = self.querySelector('.SmGrid');
          var first = null;
          doc.querySelectorAll('.SmGrid .SmGrid__Item').forEach(function (item, i) {
            item.style.animationDelay = (i * 40) + 'ms';
            var node = document.importNode(item, true);
            grid.appendChild(node);
            if (!first) first = node;
          });
          var paging = self.querySelector('[data-sm-paging]');
          var newPaging = doc.querySelector('[data-sm-paging]');
          if (paging && newPaging) paging.innerHTML = newPaging.innerHTML;
          else if (paging) paging.remove();
          var link = first && first.querySelector('a');
          if (link) link.focus({ preventScroll: true });
        })
        .catch(function () { window.location.href = next; });
    }

    /* ---------------- grid view ---------------- */
    setView(btn) {
      var grid = this.querySelector('.SmGrid');
      if (!grid) return;
      var mobile = btn.hasAttribute('data-sm-view-mobile');
      var value = btn.dataset.smView;
      if (mobile) { grid.dataset.colsM = value; store('smColsM', value); }
      else { grid.dataset.cols = value; store('smColsD', value); }
      this.applyView();
    }

    applyView() {
      var grid = this.querySelector('.SmGrid');
      if (!grid) return;
      if (this.dataset.viewToggle === 'true') {
        var d = store('smColsD'), m = store('smColsM');
        if (d) grid.dataset.cols = d;
        if (m) grid.dataset.colsM = m;
      }
      this.querySelectorAll('[data-sm-view]').forEach(function (b) {
        var mobile = b.hasAttribute('data-sm-view-mobile');
        var on = b.dataset.smView === (mobile ? grid.dataset.colsM : grid.dataset.cols);
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    /* ---------------- drawer ---------------- */
    openFilters() {
      if (!this.panel) return;
      this._focus = document.activeElement;
      this.panel.classList.add('is-open');
      this.panel.setAttribute('aria-hidden', 'false');
      if (this.overlay) this.overlay.classList.add('is-open');
      document.documentElement.classList.add('SmLocked');
      this.querySelectorAll('[data-sm-open-filters]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var close = this.panel.querySelector('[data-sm-close]');
      if (close) setTimeout(function () { close.focus(); }, 60);
    }

    closeFilters() {
      if (!this.panel || !this.panel.classList.contains('is-open')) return;
      this.panel.classList.remove('is-open');
      if (this.isDrawer()) this.panel.setAttribute('aria-hidden', 'true');
      if (this.overlay) this.overlay.classList.remove('is-open');
      document.documentElement.classList.remove('SmLocked');
      this.querySelectorAll('[data-sm-open-filters]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (this._focus) this._focus.focus();
    }

    isDrawer() { return this.layout === 'drawer' || !DESKTOP.matches; }

    /* ---------------- quick add ---------------- */
    quickAdd(btn) {
      if (btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      var self = this;
      var drawerSection = document.getElementById('shopify-section-cart-drawer');
      var body = { items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] };
      if (drawerSection && this.dataset.refreshDrawer === 'true') body.sections = 'cart-drawer';

      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add to cart');

          if (res.data.sections && res.data.sections['cart-drawer'] && drawerSection) {
            var doc = new DOMParser().parseFromString(res.data.sections['cart-drawer'], 'text/html');
            var fresh = doc.getElementById('shopify-section-cart-drawer');
            drawerSection.innerHTML = fresh ? fresh.innerHTML : doc.body.innerHTML;
          }
          return fetch(ROOT + 'cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          self.updateCount(cart.item_count);
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          var item = cart.items && cart.items[0];
          self.afterAdd(item);
        })
        .catch(function (err) { self.toast(null, err.message); })
        .finally(function () { btn.classList.remove('is-loading'); });
    }

    updateCount(count) {
      document.querySelectorAll('.CartCountBubble').forEach(function (b) { b.classList.toggle('Visible', count > 0); });
      document.querySelectorAll('.CartCountBubble__Count, [data-cart-count]').forEach(function (c) {
        if (!c.classList.contains('VisuallyHidden')) c.textContent = count;
      });
    }

    afterAdd(item) {
      var mode = this.dataset.afterAdd;
      var cartUrl = this.dataset.cartUrl || ROOT + 'cart';
      if (mode === 'cart') { window.location.href = cartUrl; return; }
      if (mode === 'drawer') {
        var trigger = document.querySelector('#Header__CartTrigger[data-tg-toggle="Drawer"], [data-tg-target="#CartDrawer"]');
        if (trigger) { trigger.click(); return; }
      }
      this.toast(item, this.dataset.addedText || 'Added to your cart', cartUrl);
    }

    toast(item, message, link) {
      var t = document.querySelector('.SmToast');
      if (!t) {
        t = document.createElement('div');
        t.className = 'SmToast';
        t.setAttribute('role', 'status');
        t.setAttribute('aria-live', 'polite');
        document.body.appendChild(t);
      }
      t.innerHTML = '';
      if (item && item.image) {
        var img = document.createElement('img');
        img.src = item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=120';
        img.alt = '';
        t.appendChild(img);
      }
      var box = document.createElement('div');
      if (item) { var s = document.createElement('strong'); s.textContent = item.product_title; box.appendChild(s); box.appendChild(document.createElement('br')); }
      box.appendChild(document.createTextNode(message));
      t.appendChild(box);
      if (link) {
        var a = document.createElement('a');
        a.href = link; a.textContent = this.dataset.viewCartText || 'View cart';
        t.appendChild(a);
      }
      t.classList.add('is-visible');
      clearTimeout(this._toast);
      this._toast = setTimeout(function () { t.classList.remove('is-visible'); }, 3000);
    }
  }

  customElements.define('sm-collection', SmCollection);
})();
